import React, {useContext, useEffect, useState} from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {Form, Main_Loader, PageAlwaysVisible, PageDesktopPadding, PageTitle, Single_, ThemeContext, device} from 'monica-alexandria';
import {useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {Checkout} from '../../styles/Layout.css';
import {calculate_tax_manual, get_artist_checkout_plan} from '../../services/api/Subscriptions';
import i18n from '../../localization/i18next';
import Lois_Checkout from './components/Lois_Checkout';
import Summary_Shift from './components/Summary_Shift';
import Artist_Payment from '../artist/components/Artist_Payment';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_TEST);

const CheckoutGrid = styled.div`
  display: grid;
  grid-template-columns: 30rem 1fr;
  grid-gap: 4rem;
  align-items: flex-start;

  @media ${device.xl} {
    grid-template-columns: 1fr;
  }
`;

export default function ARTIST_SUBSCRIBE() {
  const location = useLocation();
  const {t} = useTranslation();
  const {theme} = useContext(ThemeContext);
  const redirect = new URLSearchParams(location.search).get('redirect') || '';
  const [plan, setPlan] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState('GR');
  const lang = i18n.language || 'el';

  useEffect(() => {
    get_artist_checkout_plan().then(data => setPlan(data || false));
  }, []);

  useEffect(() => {
    if (!plan) return;
    calculate_tax_manual(selectedCountry, false, plan.amount, true)
      .then(data => {
        const tax = Math.round(plan.amount * Number(data?.taxCalculation?.taxPercentage || 0));
        setInvoice({tax, total: plan.amount + tax});
      });
  }, [plan, selectedCountry]);

  const elementsOptions = plan && invoice ? {
    mode: 'subscription',
    amount: invoice.total,
    currency: plan.currency,
    paymentMethodCreation: 'manual',
    locale: lang,
    appearance: {theme: theme === 'dark' ? 'night' : 'stripe', labels: 'floating', variables: {fontSizeBase: '1.6', spacingUnit: '4', borderRadius: '1rem'}}
  } : null;

  return (
    <Checkout>
      <PageAlwaysVisible>
        <PageTitle><h1>{t('Artist subscription')}</h1></PageTitle>
        {plan === null ? <Main_Loader></Main_Loader> : null}
        {plan === false ? <Single_ title={t('Unavailable')} subtitle={t('Artist checkout could not be started. Please try again.')}></Single_> : null}
        {plan && invoice ? <CheckoutGrid>
          <Lois_Checkout category="artist" name="Artist"></Lois_Checkout>
          <Summary_Shift amount={plan.amount} tax={invoice.tax} total={invoice.total} currency={plan.currency} trial={false}></Summary_Shift>
        </CheckoutGrid> : null}
      </PageAlwaysVisible>
      {elementsOptions ? <PageAlwaysVisible><PageDesktopPadding><Form><h3>{t('Billing information')}</h3><Elements stripe={stripePromise} options={elementsOptions}><Artist_Payment selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} redirectUrl={redirect}></Artist_Payment></Elements></Form></PageDesktopPadding></PageAlwaysVisible> : null}
    </Checkout>
  );
}
